import Control from "./Control.js"
import Utils from "./Utils.js"

export default class ChromeCast extends Control {

  constructor(props, context) {
    super(props, context)
    this.state.available = false
    this.classList.add("amp-chromecast", true)
  }

  static get contextTypes() {
    return super.contextTypes
  }

  onready() {
    if (!Utils.componentEnabled(this.plugin, "chromecast"))
      return

    this.setState({available: this.player.chromecast.available})
  }

  onplaybacktargetavailabilitychange(event) {
    if (event.detail.target === "chromecast") {
      this.setState({available: event.detail.available})
    }
  }

  get available() {
    return this.state.available
  }

  onClick() {
    this.player.chromecast.launch()
  }

  render() {
    if (this.available === false)
      return null

    return super.render()
  }
}
